import { useAppNavigate } from "../../hooks/useAppNavigate";
import React from "react";
import { Button, Grid } from "@mui/material";
import { VModule, VModuleType } from "../../core/components/VModule";
import { MappedStoryType } from "../../models/modelTypes";
import { MappedStoryDetails } from "../story/components/MappedStoryDetails";

type StoryOverviewProps = {
    story?: MappedStoryType;
};
export const StoryOverview: React.FC<StoryOverviewProps> = (props: StoryOverviewProps): JSX.Element => {
    const { story } = props;
    const { push } = useAppNavigate();
    return (
        <Grid item xs={12}>
            <VModule type={VModuleType.Shade2}>
                <MappedStoryDetails story={story} />
                <Button
                    variant={"contained"}
                    color={"primary"}
                    size={"large"}
                    fullWidth
                    onClick={() => {
                        push(`/read-story/${story?.id}/`);
                    }}
                >
                    Read Story
                </Button>
            </VModule>
        </Grid>
    );
};
export default StoryOverview;
